var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuppliersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.06,
    height: 20,
    viewBox: "0 0 24.06 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_store",
    "data-name": "solid store",
    d: "M23.57,4.633,21.035.586A1.25,1.25,0,0,0,19.976,0H4.195A1.25,1.25,0,0,0,3.136.586L.6,4.633A3.485,3.485,0,0,0,2.9,9.961,4.059,4.059,0,0,0,3.433,10,3.857,3.857,0,0,0,6.316,8.7a3.86,3.86,0,0,0,5.766,0,3.86,3.86,0,0,0,5.766,0A3.87,3.87,0,0,0,20.73,10a4.016,4.016,0,0,0,.535-.035A3.481,3.481,0,0,0,23.57,4.633ZM20.738,11.25a4.956,4.956,0,0,1-1.152-.148V15h-15V11.1a5.175,5.175,0,0,1-1.152.148,5.27,5.27,0,0,1-.7-.047,4.913,4.913,0,0,1-.641-.141V18.75A1.249,1.249,0,0,0,3.339,20h17.5a1.249,1.249,0,0,0,1.25-1.25V11.063a3.989,3.989,0,0,1-.641.141,5.432,5.432,0,0,1-.711.047Z",
    transform: "translate(-0.056)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliersIcon);
export default __webpack_public_path__ + "static/media/suppliers-icon.9a3341fe1e98d4ee1b43c860764b29a7.svg";
export { ForwardRef as ReactComponent };